import { ExternalLink, Ruler, Layers } from "lucide-react";
import { motion } from "framer-motion";

const ProductCard = ({ product }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="card-soft product-card p-6 md:p-8"
      data-testid={`product-card-${product.id}`}
    >
      {/* Product Image */}
      <div className="relative mb-6 overflow-hidden rounded-2xl bg-[#FCFAF8]">
        <img
          src={product.image_url}
          alt={`${product.name} ${product.size}`}
          className="w-full h-64 object-cover image-rounded"
          data-testid={`product-image-${product.id}`}
        />
        <div className="absolute top-4 right-4">
          <span
            className="bg-[#ADD8E6] text-[#1A1A1A] font-bold px-4 py-2 rounded-full text-sm"
            data-testid={`product-size-badge-${product.id}`}
          >
            {product.size}
          </span>
        </div>
      </div>

      {/* Product Info */}
      <div className="space-y-4">
        <h3
          className="heading-3"
          data-testid={`product-name-${product.id}`}
        >
          {product.name} - {product.size}
        </h3>

        <p
          className="body-text text-sm"
          data-testid={`product-description-${product.id}`}
        >
          {product.description}
        </p>

        {/* Dimensions */}
        <div className="flex flex-wrap gap-4 py-4 border-y border-[#1A1A1A]/10">
          <div className="flex items-center gap-2" data-testid={`product-height-${product.id}`}>
            <Ruler className="w-4 h-4 text-[#808080]" />
            <span className="text-sm text-[#4A4A4A]">
              Высота: <strong className="text-[#1A1A1A]">{product.dimensions.height}</strong>
            </span>
          </div>
          <div className="flex items-center gap-2" data-testid={`product-width-${product.id}`}>
            <Ruler className="w-4 h-4 text-[#808080] rotate-90" />
            <span className="text-sm text-[#4A4A4A]">
              Ширина: <strong className="text-[#1A1A1A]">{product.dimensions.width}</strong>
            </span>
          </div>
          <div className="flex items-center gap-2" data-testid={`product-shelves-${product.id}`}>
            <Layers className="w-4 h-4 text-[#808080]" />
            <span className="text-sm text-[#4A4A4A]">
              Полок: <strong className="text-[#1A1A1A]">{product.dimensions.shelves}</strong>
            </span>
          </div>
        </div>

        {/* Features */}
        <ul className="space-y-2">
          {product.features.slice(0, 3).map((feature, index) => (
            <li
              key={index}
              className="flex items-center gap-2 text-sm text-[#4A4A4A]"
              data-testid={`product-feature-${product.id}-${index}`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#98FF98]" />
              {feature}
            </li>
          ))}
        </ul>

        {/* Marketplace Buttons */}
        <div className="flex flex-wrap gap-3 pt-4">
          {product.wildberries_url && (
            <a
              href={product.wildberries_url}
              target="_blank"
              rel="noopener noreferrer"
              className="marketplace-btn wildberries"
              data-testid={`product-wb-btn-${product.id}`}
            >
              <ExternalLink className="w-4 h-4" />
              Wildberries
            </a>
          )}
          {product.ozon_url && (
            <a
              href={product.ozon_url}
              target="_blank"
              rel="noopener noreferrer"
              className="marketplace-btn ozon"
              data-testid={`product-ozon-btn-${product.id}`}
            >
              <ExternalLink className="w-4 h-4" />
              Ozon
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;
